<template>
  <div class="container-xxl">
    <titulo-grande texto="Cursos" posicao="left" />
    <div class="row">
      <CardCursos :ativa_placeholder="ativa_placeholder" v-for="dado in dados_carregado" @abre_modal="carregar_curso()"
        :dados="dado" :caminho_imagem="$api_link + 'download/img/'" :key="dado.id" />
      <CardCursos v-if="ativa_placeholder" :ativa_placeholder="ativa_placeholder" />
      <CardCursos v-if="ativa_placeholder" :ativa_placeholder="ativa_placeholder" />
      <CardCursos v-if="ativa_placeholder" :ativa_placeholder="ativa_placeholder" />

      <modal tamanho_modal="modal-fullscreen" textoBtnChamada="" id_modal="modal_curso" :exibe_botao="false"
        :titulo-modal="dados_modal_curso.titulo" @hidden="hidden">
        <template #default>
          <div class="row h-100">
            <div class="col-md-8 col-lg-9 col-xl-10 h-100 overflow-auto">
              <div class="container-xxl" style="height: 540px;" v-if="dados_modal_aula_atual.link_video">
                <youtube :ativa_placeholder="ativa_placeholder" :link="dados_modal_aula_atual.link_video"></youtube>
              </div>
              <div class="col-12">
                <h4>
                  {{ dados_modal_aula_atual.titulo_aula }}
                  <hr class="mb-4">
                </h4>

                <acordeon :ativa_placeholder="ativa_placeholder" :dados="dados_acordeon" />
              </div>
            </div>
            <div class="col-md-4 col-lg-3 col-xl-2 border-start">
              <div class="alert alert-dark">
                Aulas
              </div>
              <div class="overflow-scroll overflow-auto" style="height: 90%; position: static;">
                <ol class="list-group list-group-flush">
                  <li class="list-group-item" v-for="(al, index) in dados_modal_aulas" :key="al.id">
                    <button
                      :class="[(dados_modal_aula_atual.id == al.id ? 'btn-info text-white' : 'btn-dark'), 'btn', 'w-100', 'text-start']"
                      :id="'aula_' + index" @click="carregar_aula(al.id)">
                      <i class="bi bi-camera-reels"></i> {{ al.titulo_aula }}
                    </button>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </template>
      </modal>

      <div v-if="dados_provas.length > 0">
        <titulo-grande texto="Prova" posicao="left" />

        <div class="row">
          <CardCursos :ativa_placeholder="ativa_placeholder" v-for="dado in dados_provas" @abre_modal="carregar_prova()"
            :dados="dado" caminho_imagem="" :key="dado.id"
            :txt_btn="(dado.nota == null ? 'Iniciar Prova' : 'Refazer Prova')" />
          <CardCursos v-if="ativa_placeholder" :ativa_placeholder="ativa_placeholder" />
          <CardCursos v-if="ativa_placeholder" :ativa_placeholder="ativa_placeholder" />
          <CardCursos v-if="ativa_placeholder" :ativa_placeholder="ativa_placeholder" />
        </div>

        <modal tamanho_modal="modal-fullscreen" textoBtnChamada="" id_modal="modal_prova_curso" :exibe_botao="false"
          :titulo-modal="dados_modal_prova.titulo" @hidden="hidden">
          <template #default>
            <div class="row h-100">
              <div class="container">
                <div class="container">
                  <div class="alert alert-success text-center mb-5" role="alert">
                    Regras: <br>
                    <p>- Não sair da prova enquanto responde</p>
                    <p>- Não recarregar a página enquanto faz a prova</p>
                    <p>- O botão para finalizar a prova ficará disponivel ao responder todas as perguntas.</p>
                    <p></p>
                    Leia as perguntas com atenção, e boa sorte!
                  </div>
                  <div class="placeholder-glow" v-if="ativa_placeholder">
                    <ul class="list-group list-group-numbered">
                      <li class="list-group-item" v-for="(num, ind) in 2" :key="ind"><span class="placeholder w-100"
                          style="height: 26px;"></span>
                        <ul class="list-group list-group-flush mb-4">
                          <li class="list-group-item" v-if="num">
                            <span class="placeholder w-100" style="height: 26px;"></span>
                          </li>
                          <li class="list-group-item" :id="'list_1_' + num" v-if="num">
                            <span class="placeholder w-100" style="height: 26px;"></span>
                          </li>
                          <li class="list-group-item" :id="'list_2_' + num" v-if="num">
                            <span class="placeholder w-100" style="height: 26px;"></span>
                          </li>
                          <li class="list-group-item" :id="'list_3_' + num" v-if="num">
                            <span class="placeholder w-100" style="height: 26px;"></span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <fieldset>
                    <ol class="list-group list-group-numbered">
                      <li class="list-group-item" v-for="ask in dados_provas_perguntas" :key="ask.id"><b>{{ ask.pergunta
                      }}</b>
                        <ul class="list-group list-group-flush mb-4">
                          <li class="list-group-item" :id="'list_0_' + ask.id" v-if="ask.a">
                            <input class="form-check-input me-2" type="radio" v-model="respostas_prova[ask.id]"
                              :name="'ask_' + ask.id" value="0" :id="'ask_0_' + ask.id">
                            <label class="form-check-label" :for="'ask_0_' + ask.id" v-html="ask.a"></label>
                          </li>
                          <li class="list-group-item" :id="'list_1_' + ask.id" v-if="ask.b">
                            <input class="form-check-input me-2" type="radio" v-model="respostas_prova[ask.id]"
                              :name="'ask_' + ask.id" value="1" :id="'ask_1_' + ask.id">
                            <label class="form-check-label" :for="'ask_1_' + ask.id" v-html="ask.b"></label>
                          </li>
                          <li class="list-group-item" :id="'list_2_' + ask.id" v-if="ask.c">
                            <input class="form-check-input me-2" type="radio" v-model="respostas_prova[ask.id]"
                              :name="'ask_' + ask.id" value="2" :id="'ask_2_' + ask.id">
                            <label class="form-check-label" :for="'ask_2_' + ask.id" v-html="ask.c"></label>
                          </li>
                          <li class="list-group-item" :id="'list_3_' + ask.id" v-if="ask.d">
                            <input class="form-check-input me-2" type="radio" v-model="respostas_prova[ask.id]"
                              :name="'ask_' + ask.id" value="3" :id="'ask_3_' + ask.id">
                            <label class="form-check-label" :for="'ask_3_' + ask.id" v-html="ask.d"></label>
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </fieldset>
                </div>
              </div>
            </div>
          </template>
          <template #botaoPersonalizado>
            <fieldset>
              <button type="button" @click.prevent="finaliza_prova"
                :class="['btn btn-primary', (Object.keys(respostas_prova).length < (Object.keys(dados_provas_perguntas).length - 1) ? 'disabled' : '')]">
                Finalizar prova
                <Spinner :visivel="false" id="loading" />
              </button>
            </fieldset>
          </template>
        </modal>

      </div>

      <Paginacao qtd_paginas="1" pagina_prop="1" @paginar="paginar" />
    </div>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue'
import CardCursos from '@/components/CardCursos.vue';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';
import Paginacao from '../components/Paginacao.vue';
import Modal from '@/components/Modal.vue';
import { DadosStore } from '@/stores/DadosPinia';
import Acordeon from '../components/acordeon.vue';
import Youtube from '../components/Youtube.vue';
import ListaArquivos from '@/components/ListaArquivos.vue';
import { bloqueia_campos, meta_default, porcentagem } from '@/assets/js/functions';
import { toastr } from '@/plugins/toast';

export default {
  components: { TituloGrande, CardCursos, Paginacao, Modal, Acordeon, Youtube, ListaArquivos },
  name: 'Cursos',
  data() {
    return {
      auth: AuthStore(),
      DadosAula: DadosStore(),
      dados_carregado: {},
      dados_modal_curso: {},
      dados_modal_aulas: {},
      dados_modal_aula_atual: {},

      dados_provas: {},
      dados_modal_prova: {},
      dados_provas_perguntas: {},
      ativa_placeholder: false,

      respostas_prova: {},
    }
  },
  metaInfo: {
    title: 'Cursos',
    meta: meta_default("Cursos")
  },
  methods: {
    async carrega_dados() {
      this.ativa_placeholder = true
      this.dados_carregado = await api.get('courses/list_site', { Authorization: this.auth.token });

      this.ativa_placeholder = false
    },
    async carrega_provas() {
      this.ativa_placeholder = true
      this.dados_provas = await api.get('courses/tests', { Authorization: this.auth.token });
      this.ativa_placeholder = false
    },
    async paginar(temp) {
      // console.log(temp);
    },
    async hidden() {
      this.dados_modal_curso = {}
      this.dados_modal_aulas = {}
      this.dados_modal_aula_atual = {}
      this.dados_arquivos_aula = {}
      this.dados_modal_prova = {}
      this.dados_provas_perguntas = {}
      this.respostas_prova = {}
      bloqueia_campos(false);
    },
    async carregar_curso(info) {
      this.ativa_placeholder = true
      document.querySelector("#btn_modal_curso").click()
      this.dados_modal_curso = this.DadosAula.CursoAberto;
      this.dados_modal_aulas = await api.get('courses/lesson/list_site/' + this.dados_modal_curso.id, { Authorization: this.auth.token })

      if (this.dados_modal_aulas.length > 0) {
        setTimeout(() => {
          document.querySelector("#aula_0").click()
        }, 500);
      }
      this.ativa_placeholder = false
    },
    async carregar_aula(ind) {
      this.ativa_placeholder = true
      await this.listar_arquivos(ind)
      this.dados_modal_aula_atual = await api.get('courses/lesson/list_site/' + this.dados_modal_curso.id + '/' + ind, { Authorization: this.auth.token })
      this.ativa_placeholder = false
    },
    async listar_arquivos(id) {
      this.ativa_placeholder = true
      this.dados_arquivos_aula = await api.get('courses/lesson/files/list/' + id, { Authorization: this.auth.token });
      this.ativa_placeholder = false
    },
    async carregar_prova() {
      this.ativa_placeholder = true
      document.querySelector("#btn_modal_prova_curso").click()
      this.dados_modal_prova = this.DadosAula.CursoAberto;
      this.dados_provas_perguntas = await api.get('courses/tests/asks/' + this.dados_modal_prova.id, { Authorization: this.auth.token })
      this.ativa_placeholder = false
    },
    async finaliza_prova() {
      const campos = document.querySelectorAll('fieldset')
      campos.forEach((campo) => {
        campo.setAttribute("disabled", true);
      })
      this.ativa_placeholder = true
      var total_ask = (Object.keys(this.dados_provas_perguntas).length - 1);
      var correct_ans = 0;
      var media_acerto = 50;
      this.dados_provas_perguntas.forEach(ans => {
        document.getElementById('list_' + ans.resposta + '_' + ans.id).classList.add('bg-success')
        if (this.respostas_prova[ans.id] == ans.resposta) {
          correct_ans++;
        } else {
          document.getElementById('list_' + this.respostas_prova[ans.id] + '_' + ans.id).classList.add('bg-danger')
        }
      });
      var nota_final = porcentagem(total_ask, correct_ans);
      if (nota_final >= media_acerto) {
        toastr.sucesso('Parabbéns, você foi Aprovado. Sua nota é: ' + nota_final);
      } else {
        toastr.erro('Infelizmente você não conseguiu a média e foi Reprovado, revise as respostas e tente novamente. <br> Sua nota é: ' + nota_final);
      }
      var confere_dados = await api.post('courses/tests/answers/' + this.dados_modal_prova.id, { nota: nota_final }, { Authorization: this.auth.token })
      if (confere_dados.status == 200) {
        await this.auth.renewToken()
        this.carrega_dados();
        this.carrega_provas();
      } else if (confere_dados.status >= 400) {
        toastr.erro("Falha ao salvar dados no banco de dados, Tente finalizar a prova novamente.")
        campos.forEach((campo) => {
          campo.removeAttribute("disabled");
        })
      }

      this.ativa_placeholder = false
    }
  },
  computed: {
    dados_acordeon: function () {
      return [{ 'titulo': 'Descrição', 'texto': this.dados_modal_aula_atual.descricao_aula }, { 'titulo': 'Arquivos para estudos', 'lista_arquivo': this.dados_arquivos_aula }];
    },
  },
  mounted() {
    this.carrega_dados()
    this.carrega_provas()

  },
}
</script>

<style scoped>
/* div {
  border: 1px solid red;
} */
</style>